import React from 'react';
import { useSelector } from 'react-redux';

import { useTranslation } from 'src/i18n';
import { getDeviceListDeviceCount, getDeviceListSummary } from 'src/module/deviceList/selector';

/* "Showing 41 devices, 26 matching the filters (2 controllers, 24 circuits)" when parent
 * controllers are listed only for their matching circuits; "Showing N devices (…)" when
 * every listed device matches, as it always does without a filter. */
export default function DeviceListSummary () {
  const { t, tPlural } = useTranslation();
  const summary = useSelector(getDeviceListSummary);
  const deviceCount = useSelector(getDeviceListDeviceCount);

  let text = '';
  if (summary) {
    const breakdown = t('deviceList.summary.breakdown', {
      controllers: tPlural('deviceList.summary.controllers', summary.controllers),
      circuits: tPlural('deviceList.summary.circuits', summary.circuits)
    });
    let headline = tPlural('deviceList.showing', summary.devices);
    if (deviceCount > summary.devices) {
      headline = tPlural('deviceList.summary.filtered', deviceCount, { matching: summary.devices });
    }
    text = `${headline} ${breakdown}`;
  }

  return (
    <p className='ds-h-6 ds-px-2 ds-py-1 ds-text-xs ds-italic ds-text-muted-foreground ds-opacity-70' aria-live='polite'>
      {text}
    </p>
  );
}
